// extracted by mini-css-extract-plugin
export default {"cls1":"U5lRXHAiFiQHrrq47X4a","cls2":"qghxFAsUgsbrMexgsVKV U5lRXHAiFiQHrrq47X4a","bookingAppRedesign":"bKmuVuTSHi9RgR5d6l64"};